import TabToggle from 'components/commons/tab-toogle'
import { InlineError, Input } from 'avo-ui'
import Datepicker from 'components/commons/datepicker'
import Timepicker from 'components/commons/timepicker'
import moment from 'moment'

export const ProductData = ({ sectionRef, productDetail, date, time, onChangeForm, onChangeDateTime, errorForm }) => {
    return (
        <div ref={sectionRef}>
            <TabToggle
                title={'Product Data'}
                content={
                    <div className={'grid grid-cols-2 gap-y-5 gap-x-16 items-start'}>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90 required'}>Kode SKU</div>
                            <Input
                                className={'flex-1'}
                                name={'sku'}
                                placeholder={'Masukkan kode SKU'}
                                value={productDetail?.sku}
                                onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                            />
                            <InlineError className={'mt-2'} message={errorForm?.sku} />
                        </div>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90 required'}>Stok</div>
                            <Input
                                type={'number'}
                                className={'flex-1'}
                                name={'stock_quantity'}
                                placeholder={'Masukkan stok'}
                                value={productDetail?.stock_quantity}
                                onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                            />
                            <InlineError className={'mt-2'} message={errorForm?.stock_quantity} />
                        </div>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90 required'}>Harga Produk</div>
                            <Input
                                type={'currency'}
                                className={'flex-1'}
                                name={'price'}
                                addonBefore={'Rp'}
                                placeholder={'Masukkan harga product'}
                                value={productDetail?.price}
                                onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                            />
                            <InlineError className={'mt-2'} message={errorForm?.price} />
                        </div>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90 required'}>Berat (Gram)</div>
                            <Input
                                type={'number'}
                                className={'flex-1'}
                                name={'weight'}
                                placeholder={'Masukkan berat'}
                                value={productDetail?.weight}
                                onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                            />
                            <InlineError className={'mt-2'} message={errorForm?.weight} />
                        </div>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90'}>Harga Diskon</div>
                            <Input
                                type={'currency'}
                                className={'flex-1'}
                                name={'sale_price'}
                                addonBefore={'Rp'}
                                placeholder={'Masukkan harga diskon'}
                                value={productDetail?.sale_price}
                                onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                            />
                            <InlineError className={'mt-2'} message={errorForm?.sale_price} />
                        </div>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90'}>Dimensi (Tinggi)</div>
                            <Input
                                type={'number'}
                                className={'flex-1'}
                                name={'height'}
                                placeholder={'Masukkan dimensi (tinggi)'}
                                value={productDetail?.height}
                                onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                            />
                            <InlineError className={'mt-2'} message={errorForm?.height} />
                        </div>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90'}>Start Sale</div>
                            <div className={'flex space-x-2'}>
                                <Datepicker
                                    name={'date-start'}
                                    className={'flex-1'}
                                    value={date?.start}
                                    maxDate={date?.end}
                                    minDate={moment()}
                                    onChange={(value) => onChangeDateTime({ name: 'start_date', value })}
                                    format={'YYYY-MM-DD'}
                                    isClearable
                                />
                                <div className={'flex-1 flex-col space-y-3'}>
                                    <Timepicker
                                        className={'flex-1'}
                                        name={'start_time'}
                                        placeholder='Pilih Waktu'
                                        value={time?.start}
                                        disabled={!date?.start}
                                        onChange={(value) => onChangeDateTime(value)}
                                    />
                                    <InlineError className={'mt-2'} message={errorForm?.sale_start} />
                                </div>
                            </div>
                        </div>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90'}>Dimensi (Panjang)</div>
                            <Input
                                type={'number'}
                                className={'flex-1'}
                                name={'length'}
                                placeholder={'Masukkan dimensi (panjang)'}
                                value={productDetail?.length}
                                onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                            />
                            <InlineError className={'mt-2'} message={errorForm?.length} />
                        </div>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90'}>End Sale</div>
                            <div className={'flex space-x-2'}>
                                <Datepicker
                                    name={'date-end'}
                                    className={'flex-1'}
                                    value={date?.end}
                                    minDate={date?.start || moment()}
                                    onChange={(value) => onChangeDateTime({ name: 'end_date', value })}
                                    format={'YYYY-MM-DD'}
                                    isClearable
                                />
                                <div className={'flex-1 flex-col space-y-3'}>
                                    <Timepicker
                                        className={'w-full'}
                                        name={'end_time'}
                                        placeholder='Pilih Waktu'
                                        value={time?.end}
                                        disabled={!date?.end}
                                        onChange={(value) => onChangeDateTime(value)}
                                    />
                                    <InlineError className={'mt-2'} message={errorForm?.sale_end} />
                                </div>
                            </div>
                        </div>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90'}>Dimensi (Lebar)</div>
                            <Input
                                type={'number'}
                                className={'flex-1'}
                                name={'width'}
                                placeholder={'Masukkan dimensi (lebar)'}
                                value={productDetail?.width}
                                onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                            />
                            <InlineError className={'mt-2'} message={errorForm?.width} />
                        </div>
                    </div>
                }
            />
        </div>
    )
}
